export interface DeleteNoticeRequest {
  id: string
  revision: number
}

export function DeleteNoticeRequestToJSON(value: DeleteNoticeRequest): any {
  return {
    id: value.id !== '' ? value.id : undefined,
    revision: value.revision !== 0 ? value.revision : undefined
  }
}
